import { ThemeProvider as NextThemesProvider } from "next-themes";
import { useEffect, type ReactNode } from "react";

interface ThemeProviderProps {
  readonly children: ReactNode;
  readonly accentColor?: string;
}

function AccentInjector({
  accentColor,
}: {
  readonly accentColor: string | undefined;
}): null {
  useEffect(() => {
    if (accentColor) {
      document.documentElement.style.setProperty("--custom-accent", accentColor);
    }
    return () => {
      document.documentElement.style.removeProperty("--custom-accent");
    };
  }, [accentColor]);

  return null;
}

export function ThemeProvider({
  children,
  accentColor,
}: ThemeProviderProps): ReactNode {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <AccentInjector accentColor={accentColor} />
      {children}
    </NextThemesProvider>
  );
}
